import { middleofficeRequest } from '../../../axios'

export const getBankingHistoryExtranet = async (coproId) => {
  try {
    const res = await middleofficeRequest.get(
      `middleoffice/condos/${coproId}/bank-accounts/current`
    )
    return res.data
  } catch (error) {
    console.log('Error ApiBankingHistory:', error)
    return []
  }
}
